import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ComplianceTemplate from '../ComplianceTemplate';

export default function TermsOfUsage() {
  return (
    <ComplianceTemplate
      title="NovaArk Services Agreement"
      dateInfo={
        <>
          Published: 15 June 2025<br />
          Effective: 31 December 2025
        </>
      }
      content={
        <>
          <Typography paragraph>
            These terms of Usage govern govern the use of NovaArk products and services. By using our products, you agree to these Terms.
          </Typography>

          <Typography paragraph>
            You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.
          </Typography>

          <Typography paragraph>
            You may not use NovaArk services for any unlawful purposes, including but not limited to unauthorized access, data scraping, or violating any applicable laws or third-party rights. Your Privacy. Your privacy is important to us. Please read the Microsoft Privacy Statement (https://go.microsoft.com/fwlink/?LinkId=521839) (the "Privacy Statement") as it describes the types of data we collect from you and your devices ("Data"), how we use your Data and the legal bases we have to process your Data. The Privacy Statement also describes how Microsoft uses
            cntant which is your comunicationes with athere gestinas subesitted by      NovaArk reserves the right to suspend or terminate access to its services for violations of these Terms of Usage, with or without notice.You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.     NovaArk reserves the right to suspend or terminate access to its services for violations of these Terms of Usage, with or without notice.
            For more details on acceptable usage, please refer to our Acceptable Use Policy. Your Privacy. Your privacy is important to us. Please read the Microsoft Privacy Statement (https://go.microsoft.com/fwlink/?LinkId=521839) (the "Privacy Statement") as it describes the types of data we collect from you and your devices ("Data"), how we use your Data and the legal bases we have to process your Data. The Privacy Statement also describes how Microsoft uses
            cntant which is your comunicationes with.
          </Typography>
        </>
      }
    />
  );
}
